module.exports = new __parcel__URL__("About-Pic-1.f7a3d00e.webp").toString();